import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  List,
  ListItem,
  ListItemText,
  Card,
  CardContent,
  Typography,
  Divider,
  Box,
  Grid,
  CardMedia,
} from "@mui/material";
import { useQuery } from "@apollo/client";
import "../../assets/css/home.css";
import "../../assets/css/integration.css"; 
import { GET_ALL_TAGS, GET_INTEGRATIONS, GET_USER_INTEGRATIONS } from "../../graphql/queries";
const IntegrationPage = (props) => {
  const [tags, setTags] = useState([]);
  const [selectedTag, setSelectedTag] = useState("All Integrations");
  const [integrations, setIntegrations] = useState([]);
  const [userIntegrations, setUserIntegrations] = useState([]);

  const {
    loading: loadingIntegrations,
    error: errorIntegrations,
    data: dataIntegrations,
  } = useQuery(GET_INTEGRATIONS);
  const {
    loading: loadingTags,
    error: errorTags,
    data: dataTags,
  } = useQuery(GET_ALL_TAGS);
  const {
    loading: loadingUserIntegrations,
    error: errorUserIntegrations,
    data: dataUserIntegrations,
  } = useQuery(GET_USER_INTEGRATIONS);

  useEffect(() => {
    if (!loadingIntegrations && !errorIntegrations) {
      setIntegrations(dataIntegrations.getIntegrations);
    }

    if (!loadingTags && !errorTags) {
      setTags(["All Integrations", "Most Used", ...dataTags.getAllTags]);
    }

    if (!loadingUserIntegrations && !errorUserIntegrations) {
      setUserIntegrations(dataUserIntegrations.getUserIntegrations);
    }
  }, [
    loadingIntegrations,
    errorIntegrations,
    dataIntegrations,
    loadingTags,
    errorTags,
    dataTags,
    loadingUserIntegrations,
    errorUserIntegrations,
    dataUserIntegrations,
  ]);
  const navigate = useNavigate();
  const filteredIntegrations = integrations.filter(
    (integration) =>
      selectedTag === "All Integrations" ||
      (selectedTag === "Most Used" &&
        userIntegrations.includes(integration.name)) ||
      integration.tags.includes(selectedTag)
  );

  return (
    <div
      style={{ display: "flex", justifyContent: "center", marginTop: "50px" }}
    >
      <Card
        style={{
          display: "flex",
          width: "100%",
          maxWidth: "1000px",
          marginRight: "20px",
          marginLeft: "20px",
        }}
      >
        <Box style={{ width: "20%", minWidth: '160px', borderRight: "1px solid gray" }}>
          <List>
            {tags.map((tag, index) => (
              <ListItem button key={index} onClick={() => setSelectedTag(tag)}>
                <ListItemText primary={tag} />
              </ListItem>
            ))}
          </List>
        </Box>

        <Box style={{ width: "80%", padding: "20px" }}>
          <Grid container spacing={3}>
            {filteredIntegrations.map((integration, index) => (
              <Grid item xs={12} md={4} key={index}>
                <Card
                  onClick={() =>
                    navigate(
                      "/biz/integrations/" +
                      integration.name.replace(/\s/g, "_").toLowerCase()
                    )
                  }
                  style={{ height: "100%" }}
                  className="integrationCard"
                >
                  <CardContent style={{ gap: "5px" }} className="flex column">
                    <img
                      width={70}
                      height={50}
                      src={integration.logo}
                      alt={integration.name}
                    />
                    <Typography variant="h6">{integration.name}</Typography>
                    <Typography variant="body2" color="text.secondary">
                      {integration.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Card>
    </div>
  );
};

export default IntegrationPage;
